export const environment = {
  production: false,
  apiUrl: '/api/v1',
  yogaContentSyncAgentId: '',
  devProdSyncApiUrl: '',
  devProdSyncButtonEnabled: true
};
